import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Circadian rhythm meltdown",
  "description": "",
  "published": "2011-04-05T00:00:00.000Z",
  "redirect_from": ["/blog/circadian-rhythm-meltdown/swizec/1596"],
  "categories": "Circadian rhythm, Conditions and Diseases, Health, Sleep Disorders, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`My `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Circadian_rhythm",
        "title": "Circadian rhythm"
      }}>{`circadian rhythm`}</a>{` has always followed its own sort of clock and I've never quite been able to look like anything other than a raging insomniac to most people. Lately though, it's gotten absolutely bonkers.`}<img parentName="p" {...{
        "src": "https://images.instagram.com/media/2011/04/05/e8f34ab0d63a46ff9108e40d81a466a6_7.jpg",
        "alt": null,
        "title": "Sunset from my window"
      }}></img></p>
    <p>{`Last Friday I actually got to sleep at a pretty reasonable hour, about 4am. This is still pretty normal. I got up at about 9 because there was some hiking I had to do. Ok sure, a bit earlier than my saturday usual, but fine. 6 hours of sleep is the daily norm after all.`}</p>
    <p>{`That evening I watched soe movies and somehow didn't go to bed until around 6am. Yikes-ish. Still, got up at 11am. A it groggy and weird, but alright, 5 hours is sill pretty r easonable for a sunday right?`}</p>
    <p>{`I think Sunday to Monday was normal. Bed at aout 4, up at about 10. Yay, let's put the weirdness of the weekend behind us.`}</p>
    <p>{`And then came Monday night. I had some work to do, but eventually fell asleep at about 4:30 anyway.`}</p>
    <p>{`Now the fun begins.`}</p>
    <p>{`I got up at 7:30.`}</p>
    <p>{`All refreshed and sooper hyper most of the day. I practically danced to work rather than walked.`}</p>
    <p>{`The eening shifted tides on me though. Suddenly I was very fucking sleepy and when my face started feeling like a mask and I couldn't recognize myself in the mirror (iphone camera) anymore I went to bed ... at 10pm.`}</p>
    <p>{`I haven't gone to bed at 10pm since I was twelve!`}</p>
    <p>{`But guess what? I got up at 3 fucking am!`}</p>
    <p>{`3am! That's my usual bed time damn it. So not only did I completely waste one of the most productive parts of the day, I was now awake through the sleepiest part of the day.`}</p>
    <p>{`Not sure what's going on, but it's being bloody stupid.`}</p>
    <p>{`PS: there's a good article on weirdos who don't need sleep over at `}<a parentName="p" {...{
        "href": "http://online.wsj.com/article/SB10001424052748703712504576242701752957910.html"
      }}>{`Wall Street Journal`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=15b65a58-9f3b-4a5d-806d-553bc7d4a89a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      